import Index from '@/pages/AddFromCatalog/Index';
import Search from '@/pages/AddFromCatalog/Search';
import Detail from '@/pages/AddFromCatalog/Partials/Detail';

export default {
  path: 'add-from-catalog',
  name: 'AddFromCatalog',
  component: Index,
  children: [{
    path: '',
    name: 'Search',
    component: Search,
  }, {
    path: 'detail/:contentId',
    name: 'CatalogDetail',
    component: Detail,
  },
  ],
};
